// extracted by mini-css-extract-plugin
export var askAiIcon = "_qu-9";
export var container = "_qu-0";
export var groupSeparator = "_qu-a";
export var highlight = "_qu-4";
export var resultIcon = "_qu-5";
export var resultItem = "_qu-7";
export var resultSubtitle = "_qu-3";
export var resultTitle = "_qu-2";
export var resultsList = "_qu-1";
export var searchGroup = "_qu-6";
export var selected = "_qu-8";